import { useContext, useEffect, useState } from "react";
import {
	Row,
	Col,
	Table,
	Button,
	notification,
	Popconfirm,
	Tooltip,
	Tag,
	Flex,
	Checkbox,
	Divider,
} from "antd";
import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlus, faTrash } from "@fortawesome/pro-regular-svg-icons";

import { POST } from "../../../../providers/useAxiosQuery";
import {
	TableDropdownFilter,
	TableGlobalSearchAnimated,
	TablePageSize,
	TablePagination,
	TableShowingEntriesV2,
	useTableScrollOnTop,
} from "../../../../providers/CustomTableFilter";
import notificationErrors from "../../../../providers/notificationErrors";
import ModalFormValidation from "../../PageProfilingPortal/components/ModalFormValidation";
import ModalDataConsent from "./ModalDataConsent";
import dayjs from "dayjs";
import PageApplicantContext from "./PageApplicantContext";

export default function TableApplicant() {
	const {
		location,

		tableFilter,
		setTableFilter,

		dataStudentExam,

		toggleModalDataConsent,
		setToggleModalDataConsent,
		toggleModalFormValidation,
		setToggleModalFormValidation,
	} = useContext(PageApplicantContext);

	const navigate = useNavigate();
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);

	const {
		mutate: mutateArchivedApplicant,
		isLoading: isLoadingArchivedApplicant,
	} = POST(`api/applicant_archived`, "student_exams_list");

	const handleSelectedArchived = (id) => {
		let data = {
			isTrash: tableFilter.isTrash,
			ids: selectedRowKeys.length > 0 ? selectedRowKeys : [id],
		};

		mutateArchivedApplicant(data, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "Applicant",
						description: res.message,
					});
				} else {
					notification.error({
						message: "Applicant",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notificationErrors(err);
			},
		});
	};

	useTableScrollOnTop("tblApplicant", location.pathname);

	return (
		<Row gutter={[12, 12]} id="tbl_wrapper_applicant">
			<Col xs={24} sm={24} md={24} lg={24}>
				<div className="tbl-top-filter">
					<Flex gap={10} vertical>
						<Flex>
							{location.pathname.includes("walk-in") && (
								<Button
									type="primary"
									icon={<FontAwesomeIcon icon={faPlus} />}
									onClick={() => {
										setToggleModalDataConsent({
											open: true,
											data: null,
										});
									}}
									name="btn_add"
								>
									Add Walk-In Applicant
								</Button>
							)}
						</Flex>
						<Flex gap={10}>
							<Button
								type={tableFilter.isTrash === 0 ? "primary" : ""}
								className={`min-w-150 ${
									tableFilter.isTrash === 0 ? "active" : ""
								}`}
								onClick={() => {
									setTableFilter((ps) => ({
										...ps,
										isTrash: 0,
									}));
									setSelectedRowKeys([]);
								}}
							>
								Active
							</Button>
							<Button
								type={tableFilter.isTrash === 1 ? "primary" : ""}
								className={`min-w-150 ${
									tableFilter.isTrash === 1 ? "active" : ""
								}`}
								onClick={() => {
									setTableFilter((ps) => ({
										...ps,
										isTrash: 1,
									}));
								}}
							>
								Archived
							</Button>

							{selectedRowKeys.length > 0 && (
								<Popconfirm
									title={
										<>
											Are you sure you want to
											<br />
											{tableFilter.isTrash === 0 ? "archive" : "restore"} the
											selected{" "}
											{selectedRowKeys.length > 1 ? "applicants" : "applicant"}?
										</>
									}
									okText="Yes"
									cancelText="No"
									onConfirm={() => {
										handleSelectedArchived();
									}}
									disabled={isLoadingArchivedApplicant}
								>
									<Button
										type="primary"
										name="btn_active_archive"
										loading={isLoadingArchivedApplicant}
										danger={tableFilter.isTrash === 0}
										className={tableFilter.isTrash === 1 ? "btn-success" : ""}
									>
										RESTORE SELECTED
									</Button>
								</Popconfirm>
							)}

							<TableGlobalSearchAnimated
								tableFilter={tableFilter}
								setTableFilter={setTableFilter}
							/>
						</Flex>
					</Flex>

					<Flex vertical gap={12} align="flex-end">
						<TablePageSize
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
						/>

						<Flex className="tbl-bottom-filter">
							<div />

							<Flex>
								<TableShowingEntriesV2 />
								<TablePagination
									tableFilter={tableFilter}
									setTableFilter={setTableFilter}
									setPaginationTotal={dataStudentExam?.data?.total}
									showLessItems={true}
									showSizeChanger={false}
									tblIdWrapper="tbl_wrapper_applicant"
								/>
							</Flex>
						</Flex>
					</Flex>
				</div>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24}>
				<Table
					id="tblApplicant"
					className="ant-table-default ant-table-striped"
					dataSource={dataStudentExam && dataStudentExam.data.data}
					rowKey={(record) => record.id}
					pagination={false}
					bordered={false}
					scroll={{ x: "max-content" }}
					sticky
					rowSelection={
						tableFilter.isTrash === 1
							? {
									selectedRowKeys,
									onChange: (selectedRowKeys) => {
										setSelectedRowKeys(selectedRowKeys);
									},
							  }
							: null
					}
					// onChange={(pagination, filters, sorter) => {
					// 	setTableFilter((prev) => ({
					// 		...prev,
					// 		category: filters.exam_category ?? [
					// 			"College",
					// 			"College of Law",
					// 			"Graduate Studies",
					// 		],
					// 		payment_status: filters.payment_status ?? ["Not Paid", "Paid"],
					// 	}));
					// }}
				>
					{tableFilter.isTrash === 0 && (
						<Table.Column
							title="Action"
							key="action"
							dataIndex="action"
							align="center"
							width={100}
							render={(text, record) => {
								// console.log("record: ", record);

								return (
									<Flex justify="center">
										<Tooltip title={"Edit Information"}>
											<Button
												type="link"
												className="primary-color"
												onClick={() => {
													navigate(
														`/applicants/walk-in/edit/${record.profile_id}`
													);
												}}
												name="btn_edit"
											>
												<FontAwesomeIcon icon={faPencil} />
											</Button>
										</Tooltip>

										<Tooltip
											title={tableFilter.isTrash === 0 ? "Archive" : "Restore"}
										>
											<Popconfirm
												title={
													<>
														Are you sure you want to
														<br />
														archive the applicant?
													</>
												}
												okText="Yes"
												cancelText="No"
												onConfirm={() => {
													handleSelectedArchived(record.id);
												}}
												disabled={isLoadingArchivedApplicant}
											>
												<Button
													type="link"
													className="primary-color text-danger"
													name="btn_edit"
												>
													<FontAwesomeIcon icon={faTrash} />
												</Button>
											</Popconfirm>
										</Tooltip>
									</Flex>
								);
							}}
						/>
					)}

					<Table.Column
						title="Student Name"
						key="fullname"
						dataIndex="fullname"
						sorter={(a, b) => a.fullname.localeCompare(b.fullname)}
						sortDirections={["descend", "ascend"]}
						width={250}
					/>

					<Table.Column
						title="Exam Schedule"
						key="exam_schedule_id"
						dataIndex="exam_schedule_id"
						sorter={(a, b) =>
							a.exam_schedule_id
								.toString()
								.localeCompare(b.exam_schedule_id.toString())
						}
						defaultSortOrder="ascend"
						width={250}
						render={(text, record) => (
							<>
								{dayjs(record.exam_date).format("MMMM DD, YYYY")} ({" "}
								{record.exam_time} )
							</>
						)}
					/>

					<Table.Column
						title="Exam Category"
						key="exam_category"
						dataIndex="exam_category"
						sorter={(a, b) => a.exam_category.localeCompare(b.exam_category)}
						defaultSortOrder="ascend"
						width={150}
						render={(text, record) => (
							<>
								{record.exam_category}{" "}
								<Tag color="blue" style={{ fontSize: "12px" }}>
									₱ {record.exam_fee}.00
								</Tag>
							</>
						)}
						// filters={
						// 	dataExamCategory
						// 		? dataExamCategory.map((item) => ({
						// 				text: item.category,
						// 				value: item.category,
						// 		  }))
						// 		: []
						// }
					/>

					<Table.Column
						title="Payment Status"
						key="payment_status"
						dataIndex="payment_status"
						sorter={(a, b) => a.payment_status.localeCompare(b.payment_status)}
						width={150}
						render={(text, record) => {
							return record.payment_status === "Not Paid" ? (
								<Tag color="#f50" style={{ fontSize: "12px" }}>
									Not Paid
								</Tag>
							) : (
								<Tag color="#87d068" style={{ fontSize: "12px" }}>
									Paid
								</Tag>
							);
						}}
						// filters={[
						// 	{ text: "Not Paid", value: "Not Paid" },
						// 	{ text: "Paid", value: "Paid" },
						// ]}
					/>
				</Table>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
				<Flex className="tbl-bottom-filter">
					<div />

					<Flex>
						<TableShowingEntriesV2 />
						<TablePagination
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
							setPaginationTotal={dataStudentExam?.data?.total}
							showLessItems={true}
							showSizeChanger={false}
							tblIdWrapper="tbl_wrapper_applicant"
						/>
					</Flex>
				</Flex>
			</Col>

			<ModalFormValidation
				toggleModalFormValidation={toggleModalFormValidation}
				setToggleModalFormValidation={setToggleModalFormValidation}
			/>

			<ModalDataConsent
				toggleModalDataConsent={toggleModalDataConsent}
				setToggleModalDataConsent={setToggleModalDataConsent}
			/>
		</Row>
	);
}
